// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/entity/opening_hours.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_common } from "../core/common_pb";
import { file_proto_model_core_date } from "../core/date_pb";
import { file_proto_model_core_timeofday } from "../core/timeofday_pb";

/**
 * Describes the file proto/model/entity/opening_hours.proto.
 */
export const file_proto_model_entity_opening_hours = /*@__PURE__*/
  fileDesc("CiZwcm90by9tb2RlbC9lbnRpdHkvb3BlbmluZ19ob3Vycy5wcm90bxIGY2FybWVuIlQKEU9wZW5pbmdIb3Vyc1BvaW50Eh4KA2RheRgBIAEoDjIRLmNhcm1lbi5EYXlPZldlZWsSHwoEdGltZRgCIAEoCzIRLmNhcm1lbi5UaW1lT2ZEYXkiZwoST3BlbmluZ0hvdXJzUGVyaW9kEicKBG9wZW4YASABKAsyGS5jYXJtZW4uT3BlbmluZ0hvdXJzUG9pbnQSKAoFY2xvc2UYAiABKAsyGS5jYXJtZW4uT3BlbmluZ0hvdXJzUG9pbnQiaAoKU3BlY2lhbERheRIaCgRkYXRlGAEgASgLMgwuY2FybWVuLkRhdGUSEQoJaXNfY2xvc2VkGAIgASgIEisKB3BlcmlvZHMYAyADKAsyGi5jYXJtZW4uT3BlbmluZ0hvdXJzUGVyaW9kIpkBCgxPcGVuaW5nSG91cnMSKwoHcGVyaW9kcxgBIAMoCzIaLmNhcm1lbi5PcGVuaW5nSG91cnNQZXJpb2QSFAoMd2Vla2RheV90ZXh0GAIgAygJEigKDHNwZWNpYWxfZGF5cxgDIAMoCzISLmNhcm1lbi5TcGVjaWFsRGF5EhwKFHNlY29uZGFyeV9ob3Vyc190eXBlGAQgASgJQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM", [file_proto_model_core_common, file_proto_model_core_date, file_proto_model_core_timeofday]);

/**
 * Describes the message carmen.OpeningHoursPoint.
 * Use `create(OpeningHoursPointSchema)` to create a new message.
 */
export const OpeningHoursPointSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_opening_hours, 0);

/**
 * Describes the message carmen.OpeningHoursPeriod.
 * Use `create(OpeningHoursPeriodSchema)` to create a new message.
 */
export const OpeningHoursPeriodSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_opening_hours, 1);

/**
 * Describes the message carmen.SpecialDay.
 * Use `create(SpecialDaySchema)` to create a new message.
 */
export const SpecialDaySchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_opening_hours, 2);

/**
 * Describes the message carmen.OpeningHours.
 * Use `create(OpeningHoursSchema)` to create a new message.
 */
export const OpeningHoursSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_opening_hours, 3);

